import {BaseCriteriaModel} from '../../base-criteria.model';
import {Optional} from 'typescript-optional';

export class WfProjectCategoryQueryCriteriaClass extends BaseCriteriaModel {
  module_guid: Optional<string> = Optional.empty();
  applet_guid: Optional<string> = Optional.empty();
  name: Optional<string> = Optional.empty();
  code: Optional<string> = Optional.empty();
  created_by_subject_guid: Optional<string> = Optional.empty();
  updated_by_subject_guid: Optional<string> = Optional.empty();
  namespace: Optional<string> = Optional.empty();

}

export class WfProjectCategoryQueryCriteriaModel {
  query = '';

  constructor(criteria: WfProjectCategoryQueryCriteriaClass) {

    if (!criteria) {
      return;
    }

    this.query += criteria.module_guid.filter(x => x !== '').map(x => '&module_guid=' + x).orElse('');
    this.query += criteria.applet_guid.filter(x => x !== '').map(x => '&applet_guid=' + x).orElse('');
    this.query += criteria.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += criteria.code.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += criteria.created_by_subject_guid.filter(x => x !== '').map(x => '&created_by_subject_guid=' + x).orElse('');
    this.query += criteria.updated_by_subject_guid.filter(x => x !== '').map(x => '&updated_by_subject_guid=' + x).orElse('');
    this.query += criteria.namespace.filter(x => x !== '').map(x => '&namespace=' + x).orElse('');

    this.query += '&status=' + criteria.status;
    this.query += '&orderBy=' + criteria.orderBy;
    this.query += '&order=' + criteria.order;
    this.query += '&offset=' + criteria.offset + '&limit=' + criteria.limit;
  }
}
